import React from 'react';
import { Bell, LogOut } from 'lucide-react';
import { supabase } from '../lib/supabase';

export const Topbar: React.FC = () => {
  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.reload();
  };

  return (
    <header className="admin-topbar">
      <div className="flex items-center gap-3">
        <h3 style={{ color: 'var(--text-primary)' }}>Dashboard</h3>
      </div>
      <div className="flex items-center gap-2">
        <button className="btn btn-ghost btn-sm" title="Benachrichtigungen">
          <Bell />
        </button>
        <button className="btn btn-ghost btn-sm" onClick={handleLogout} title="Abmelden">
          <LogOut />
        </button>
      </div>
    </header>
  );
};
